module.exports = __webpack_public_path__ + "img/1437521764.f3e93699.jpg";